export default {"src":"/_next/static/media/benefits.c245f52e.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};